module.exports = __webpack_public_path__ + "fonts/MaterialDesignIcons.0781e36.ttf";